module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_content J_rili_content"
  }, [_c('div', {
    staticClass: "ushk-rili_content-h"
  }, [_c('h3', {
    staticClass: "ushk-rili_content-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.option.title))]), _vm._v(" "), (['港股时段', '美股盘前', '美股盘后'].includes(_vm.option.title)) ? _c('p', {
    staticClass: "ushk-rili_content-desc"
  }, [_vm._v("EPS采用的是归属于股东/母公司、（稀释后）每股收益；净利润采用的是GAAP/IFRS会计准则下的净利润")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_content-b"
  }, [_c('div', {
    staticClass: "ushk-table"
  }, [_c('div', {
    staticClass: "ushk-table-head J_rili_table_head"
  }, [_c('div', {
    attrs: {
      "data-type": "fixed"
    }
  }, [_c('div', {
    staticClass: "ushk-table-head_wrap"
  }, _vm._l((_vm.option.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ushk-table-head_item",
      style: ({
        width: item[1]
      })
    }, [_vm._v("\n              " + _vm._s(item[0]) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('table', {
    staticClass: "ushk-table_body"
  }, [_c('colgroup', _vm._l((_vm.option.items), function(item, index) {
    return _c('col', {
      key: index,
      attrs: {
        "width": item[1]
      }
    })
  }), 0), _vm._v(" "), _c(_vm.option.name, {
    tag: "component",
    attrs: {
      "datas": _vm.datas,
      "none-text": _vm.option.noneText,
      "type": _vm.option.type
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd912f1","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/ListGroup.vue
// module id = 0La8
// module chunks = 3